import Vue from "vue";
import Router from "vue-router";
import Registration from "../views/Registration";
import CompletedRegistration from "../views/CompletedRegistration";
import ClosedRegistration from "../views/ClosedRegistration";
import Result from "../views/Result";
import Closed from "../views/Closed";
import Login from "../views/Login";
import store from "../store/index";

Vue.use(Router);

const navGuard = {
  beforeEnter: (to, from, next) => {
    if (store.getters.accessToken) {
      next();
    } else {
      next("/");
    }
  }
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/Registration",
      name: "Registration",
      component: Registration,
      beforeEnter: navGuard.beforeEnter
    },
    {
      path: "/CompletedRegistration",
      name: "CompletedRegistration",
      component: CompletedRegistration,
      beforeEnter: navGuard.beforeEnter
    },
    {
      path: "/ClosedRegistration",
      name: "ClosedRegistration",
      component: ClosedRegistration,
      beforeEnter: navGuard.beforeEnter
    },
    {
      path: "/Result",
      name: "Result",
      component: Result,
      beforeEnter: navGuard.beforeEnter
    },
    {
      path: "/Closed",
      name: "Closed",
      component: Closed,
      beforeEnter: navGuard.beforeEnter
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js